import {
  ADD_REVIEWER,
  GET_REVIEWER,
  EDIT_REVIEWER,
  DELETE_REVIEWER,
  BLOCK_REVIEWER,
} from "../constants/action-types";

const initilState = {
  state: "",
};

const reviewerReducer = (state = initilState, action) => {
  switch (action.type) {
    case ADD_REVIEWER:
      return {
        ...state,
        ...state.data.push(action?.payload),
      };
    case GET_REVIEWER:
      return {
        ...state,
        data: action.payload,
      };
    case EDIT_REVIEWER:
      const index = state.data.findIndex(
        (ele) => ele.id === action?.payload.id
      );
      state.data.splice(index, 1, action?.payload);
      return {
        ...state,
        ...state.data,
      };
    case DELETE_REVIEWER:
      const deleteIndex = state.data.filter(
        (ele) => ele.id !== action?.payload.id
      );
      return {
        ...state,
        data: deleteIndex,
      };
    case BLOCK_REVIEWER:
      const blockIndex = state.data.findIndex(
        (ele) => ele.id === action?.payload.id
      );
      state.data.splice(blockIndex, 1, action?.payload);
      return {
        ...state,
        ...state.data,
      };
    default:
      return state;
  }
};

export default reviewerReducer;
